import {Component, Input} from '@angular/core';
import {ControlContainer, FormGroupDirective, ReactiveFormsModule} from '@angular/forms';
import {LegalEntity} from '../../../../domain/core/legal-entity.model';
import {CheckboxComponent} from '../../../../shared/components/checkbox/checkbox.component';

@Component({
  selector: 'app-registration-consent',
  imports: [ReactiveFormsModule, CheckboxComponent],
  templateUrl: './registration-consent.component.html',
  viewProviders: [
    {provide: ControlContainer, useExisting: FormGroupDirective}
  ]
})
export class RegistrationConsentComponent {
  @Input() legalEntity!: LegalEntity;
  @Input() consentVersion!: string;
}
